/** Keep in sync with backend `backend/src/constants/runningPlans.js`. */
export const RUNNING_PLAN_IDS = ['free', 'basic', 'advanced'];

export const RUNNING_PLAN_LABELS = {
  free: 'Free Trial',
  basic: 'Basic',
  advanced: 'Advance',
};

export const PLAN_DURATION_DAYS = 30;

export function normalizeRunningPlanId(planId) {
  if (planId == null || planId === '') return null;
  const id = String(planId).toLowerCase().trim();
  if (id === 'free') return 'free';
  if (id === 'basic' || id.startsWith('basic_')) return 'basic';
  if (id === 'advanced' || id === 'advance' || id.startsWith('advanced_')) return 'advanced';
  return null;
}

export function runningPlanLabel(planId) {
  const id = normalizeRunningPlanId(planId) || 'free';
  return RUNNING_PLAN_LABELS[id] || RUNNING_PLAN_LABELS.free;
}

/** Format plan expiry for sidebar, e.g. "6 Sep 2026". */
export function formatPlanExpiryDate(planExpiresAt) {
  if (!planExpiresAt) return null;
  const d = new Date(planExpiresAt);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function isPlanExpired(planExpiresAt, now = new Date()) {
  if (!planExpiresAt) return false;
  const d = new Date(planExpiresAt);
  if (Number.isNaN(d.getTime())) return false;
  return d <= now;
}

/** Paid basic/advanced still within planExpiresAt (or legacy paid with no expiry). */
export function isPaidPlanActive(runningPlan, planExpiresAt, now = new Date()) {
  const id = normalizeRunningPlanId(runningPlan);
  if (!id || id === 'free') return false;
  if (!planExpiresAt) return true;
  const d = new Date(planExpiresAt);
  if (Number.isNaN(d.getTime())) return true;
  return d > now;
}

/** Watermarking disabled — generated kits never show a Fashdeck mark. */
export function userNeedsFashdeckWatermark() {
  return false;
}
